module.exports = __webpack_public_path__ + "img/img1.e5ff2ff2.svg";